import { IntlKey } from 'locales';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { camelCaseToWords } from 'utils/string';

export function useTranslateProductType() {
  const { formatMessage } = useIntl();

  return useCallback(
    (productType: string, commercialProductType?: string) => {
      const defaultMessage = formatMessage({
        id: `quote.products.${productType}` as IntlKey,
        defaultMessage: productType,
      });

      return commercialProductType
        ? formatMessage({
            id: `field.${commercialProductType}` as IntlKey,
            defaultMessage,
          })
        : defaultMessage;
    },
    [formatMessage],
  );
}
type Product = { productType: string; productSubType: string };
export function useTranslateProductNames(products: Product[]) {
  const translatePayoff = useTranslateProductType();
  return products.map(product => {
    const productTypeLabel = translatePayoff(product.productType);
    const productSubtypeLabel = translatePayoff(product.productSubType);

    const productName = `${productTypeLabel}/${productSubtypeLabel}`;

    return { productName, productTypeLabel, productSubtypeLabel };
  });
}
export function useTranslateProductName(productType: string, productSubType: string) {
  const translatePayoff = useTranslateProductType();
  const productTypeLabel = translatePayoff(productType);
  const productSubtypeLabel = translatePayoff(productSubType);

  const productName = `${productTypeLabel}/${productSubtypeLabel}`;

  return { productName, productTypeLabel, productSubtypeLabel };
}

export function useTranslateForm() {
  const { formatMessage } = useIntl();

  const translateLabel = useCallback(
    (labelKey: string) =>
      labelKey
        ? formatMessage({ id: `form.${labelKey}` as IntlKey, defaultMessage: camelCaseToWords(labelKey) })
        : labelKey,
    [formatMessage],
  );

  const translateFieldLabel = useCallback(
    (valueKey: string) =>
      valueKey
        ? formatMessage({ id: `field.${valueKey}` as IntlKey, defaultMessage: camelCaseToWords(valueKey) })
        : valueKey,
    [formatMessage],
  );

  return {
    translateLabel,
    translateFieldLabel,
  };
}

export function useTranslateAssetType() {
  const { formatMessage } = useIntl();

  return useCallback(
    (code: string) => {
      const key = `asset.${code}` as IntlKey;
      return formatMessage({ id: key, defaultMessage: camelCaseToWords(code) });
    },
    [formatMessage],
  );
}
